import { SxProps, Theme } from "@mui/material";
import { inarixColors } from "inarix-theme";

export const dialogTitleSx: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: "22px",
  color: "#1a1a2e",
  pb: 1,
};

export const dialogContentSx: SxProps<Theme> = {
  pt: "8px !important",
};

export const cardSx = (
  card: "a" | "b",
  hoveredCard: "a" | "b" | null,
): SxProps<Theme> => ({
  display: "flex",
  minWidth: 25,
  justifyContent: "space-between",
  cursor: "pointer",
  border:
    hoveredCard === card
      ? `2px solid ${inarixColors.main_inarix}`
      : "2px solid #e0e0e0",
  boxShadow: hoveredCard === card ? "none" : undefined,
  borderRadius: "12px",
  transition: "border 0.15s",
});

export const iconLeftSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  pl: 2,
};

export const iconRightSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  pr: 2,
};

export const contentBoxSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
};

export const cardContentBaseSx: SxProps<Theme> = {
  flexDirection: "column",
};

export const cardContentFlexSx: SxProps<Theme> = {
  flex: "1 0 auto",
};

export const subtitleSx: SxProps<Theme> = {
  color: "text.secondary",
  fontSize: "14px",
};

export const secondCardWrapperSx: SxProps<Theme> = { mt: 2 };

export const iconSx = (
  card: "a" | "b",
  hoveredCard: "a" | "b" | null,
): SxProps<Theme> => ({
  fontSize: 32,
  color: hoveredCard === card ? inarixColors.main_inarix : "text.secondary",
});

export const chevronSx = (
  card: "a" | "b",
  hoveredCard: "a" | "b" | null,
): SxProps<Theme> => ({
  color: hoveredCard === card ? inarixColors.main_inarix : "text.secondary",
});

export const titleTypographySx = (
  card: "a" | "b",
  hoveredCard: "a" | "b" | null,
): SxProps<Theme> => ({
  fontSize: "18px",
  fontWeight: hoveredCard === card ? 600 : 400,
  color: hoveredCard === card ? "#1a1a2e" : "text.secondary",
});
